import { combineReducers } from "redux";
import { TrackedListColumns } from "../enum/tracked-list-columns";
import { ITrackedListDto } from "../interface/dto/tracked-lists.dto";
import {
    IListToTrackState,
    listToTrackReducer,
} from "./list-to-track/list-to-track.reducer";
import {
    ITrackedListActions,
    TrackedListActionTypes,
} from "./tracked-lists.actions";

interface ITrackedListsTableState {
    isLoading: boolean;
    isTrackListLoading: boolean;
    error?: string;
    trackError?: string;
    trackedLists?: ITrackedListDto;
    pagination: {
        currentPage: number;
        itemsPerPage: number;
        totalItems: number;
    };
    searchQuery?: string;
    sorting: {
        column: TrackedListColumns;
        order: "asc" | "desc";
    };
}

const initTrackList: ITrackedListsTableState = {
    isLoading: false,
    isTrackListLoading: false,
    pagination: {
        currentPage: 1,
        itemsPerPage: 10,
        totalItems: 0,
    },
    sorting: {
        column: TrackedListColumns.NAME,
        order: "asc",
    },
};

const trackedListTableReducer = (
    state = initTrackList,
    action: ITrackedListActions,
): ITrackedListsTableState => {
    switch (action.type) {
        case TrackedListActionTypes.TRACKED_LIST_INIT:
            return {
                ...state,
                pagination: initTrackList.pagination,
                searchQuery: undefined,
                sorting: initTrackList.sorting,
            };

        case TrackedListActionTypes.TRACKED_LIST_LOAD_LISTS:
            return {
                ...state,
                isTrackListLoading: true,
                error: undefined,
            };
        case TrackedListActionTypes.TRACKED_LIST_LOAD_LISTS_SUCCESS:
            return {
                ...state,
                isTrackListLoading: false,
                trackedLists: action.payload,
                pagination: {
                    ...state.pagination,
                    totalItems: action.payload.total,
                },
            };
        case TrackedListActionTypes.TRACKED_LIST_LOAD_LISTS_ERROR:
            return {
                ...state,
                trackedLists: undefined,
                isTrackListLoading: false,
                error: action.payload.error,
            };
        case TrackedListActionTypes.TRACKED_LIST_SET_SEARCHQUERY:
            return {
                ...state,
                searchQuery: action.payload,
                pagination: { ...state.pagination, currentPage: 1 },
            };
        case TrackedListActionTypes.TRACKED_LIST_SET_PAGINATION:
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    ...action.payload,
                    currentPage:
                        action.payload.itemsPerPage !==
                        state.pagination.itemsPerPage
                            ? 1
                            : action.payload.currentPage,
                },
            };
        case TrackedListActionTypes.TRACKED_LIST_SET_SORTING:
            return { ...state, sorting: action.payload };
        case TrackedListActionTypes.TRACKED_LIST_TRACK_SUCCESS:
            return { ...state, isLoading: false, trackError: undefined };
        case TrackedListActionTypes.TRACKED_LIST_TRACK_ERROR:
            return {
                ...state,
                isLoading: false,
                trackError: action.payload.error,
            };
        case TrackedListActionTypes.TRACKED_LIST_TRACK:
            return {
                ...state,
                isLoading: true,
                trackError: undefined,
            };
        default:
            return state;
    }
};
export interface ITrackedListsState {
    table: ITrackedListsTableState;
    listToTrack: IListToTrackState;
}

export const trackedListsReducer = combineReducers({
    table: trackedListTableReducer,
    listToTrack: listToTrackReducer,
});
